import VNavigationDrawer from './VNavigationDrawer'

/* istanbul ignore next */
VNavigationDrawer.install = function install (Vue) {
  Vue.component(VNavigationDrawer.name, VNavigationDrawer)
}

export { VNavigationDrawer }
export default VNavigationDrawer
